import React from "react";
import { secondaryTextColorOppositeShade } from "../../utils/constants";

export default function NewComentsTaskIcon({ color = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 462.41">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Layer_1" data-name="Layer 1">
          <path
            fill={color}
            d="M377.38,274.72a7.5,7.5,0,0,0-7.5,7.5v88.41a7.93,7.93,0,0,1-7.91,7.94H211a7.5,7.5,0,1,0,0,15H362a23,23,0,0,0,22.91-22.94V282.22A7.5,7.5,0,0,0,377.38,274.72Z"
          />
          <path fill={color} d="M85.27,223.17H299.62a7.5,7.5,0,0,0,0-15H85.27a7.5,7.5,0,0,0,0,15Z" />
          <path fill={color} d="M85.27,268.35H299.62a7.5,7.5,0,0,0,0-15H85.27a7.5,7.5,0,1,0,0,15Z" />
          <path fill={color} d="M85.27,313.54H198.41a7.5,7.5,0,1,0,0-15H85.27a7.5,7.5,0,1,0,0,15Z" />
          <path
            fill={color}
            d="M400.18,0A111.86,111.86,0,0,0,289.4,127H22.91A23,23,0,0,0,0,150V370.63a23,23,0,0,0,22.91,22.94H66V447c0,9.91,4.91,13.42,7.84,14.63a11.29,11.29,0,0,0,4.27.82c3,0,7.13-1.16,11.6-5.63l63.13-63.22H175a7.5,7.5,0,0,0,0-15H149.73a7.51,7.51,0,0,0-5.31,2.2L81,444.27V386.06a7.5,7.5,0,0,0-7.5-7.5H22.91A7.93,7.93,0,0,1,15,370.63V150A7.93,7.93,0,0,1,22.91,142h269.6a112.27,112.27,0,0,0,77.37,77.45v27.75a7.5,7.5,0,1,0,15,0V222.58A111.82,111.82,0,1,0,400.18,0Zm0,208.63A96.82,96.82,0,1,1,497,111.81a96.92,96.92,0,0,1-96.82,96.82Z"
          />
          <path
            fill={color}
            d="M430.27,139.24a42.86,42.86,0,0,1-60.18,0,7.5,7.5,0,0,0-10.56,10.66,57.92,57.92,0,0,0,81.3,0,7.5,7.5,0,1,0-10.56-10.66Z"
          />
          <path
            fill={color}
            d="M443.14,77.92a25.3,25.3,0,0,0-25.4,25.15,7.5,7.5,0,0,0,15,0,10.4,10.4,0,0,1,20.79,0,7.5,7.5,0,0,0,15,0A25.3,25.3,0,0,0,443.14,77.92Z"
          />
          <path
            fill={color}
            d="M367.63,103.07a7.5,7.5,0,0,0,15,0,25.4,25.4,0,0,0-50.8,0,7.5,7.5,0,0,0,15,0,10.4,10.4,0,0,1,20.8,0Z"
          />
          <path
            fill={color}
            d="M12.5,98.34H147a7.5,7.5,0,0,0,0-15H15V28.89H208.15V83.34H183a7.5,7.5,0,0,0,0,15h27.65a12.52,12.52,0,0,0,12.5-12.5V26.39a12.51,12.51,0,0,0-12.5-12.5H12.5A12.51,12.51,0,0,0,0,26.39V85.84A12.52,12.52,0,0,0,12.5,98.34Z"
          />
          <path
            fill={color}
            d="M181.76,56.11a7.5,7.5,0,0,0-7.5-7.5H42.5a7.5,7.5,0,0,0,0,15H174.26A7.5,7.5,0,0,0,181.76,56.11Z"
          />
        </g>
      </g>
    </svg>
  );
}
